import _ from 'lodash';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { LineChart, tokens } from '@treams/treams-ui';

import DashboardCard from '../DashboardCard';
import DoughnutMetric from './DoughnutMetric';

export default function ParticipationRatesMetric(props: {
	data: graphql.AnalyticsEngagementParticipation;
}) {
	const { t } = useTranslation();

	const rates = props.data.datapoints.map(
		(datapoint) => (datapoint.completed ?? 0) / (datapoint.total ?? 1),
	);
	const meanRate = rates.length > 0 ? _.mean(rates) : 0;

	return (
		<DashboardCard
			title={t('dashboard.metrics.engagement.participationRates.title')}
			description={t('dashboard.metrics.engagement.participationRates.description')}
		>
			<Flex flexDirection="row" px={2} py={1}>
				{props.data.datapoints.length === 0 ? (
					<DoughnutMetric.Skeleton animated={false} padding={0} />
				) : (
					<DoughnutMetric
						data={[
							{
								value: meanRate,
								color: 'employee',
							},
							{
								value: 1.0 - meanRate,
								color: 'employee',
								hidden: true,
							},
						]}
						max={100}
						digits={0}
						suffix="%"
						legend={false}
						tooltip={false}
						padding={0}
					/>
				)}
				<Box flexGrow={1} p={3} ml={2}>
					<LineChart
						labels={props.data.datapoints.map((point) => moment(point.timestamp).format('DD MMM'))}
						data={props.data.datapoints.map((point) => ({
							x: new Date(point.timestamp).getTime(),
							y: (point.completed ?? 0.0) / (point.total ?? 0.0),
							tooltip: `${point.completed}/${point.total}`,
						}))}
						height={165}
						tintColor={tokens.brand.icon}
						autoBound
						bounds={[0, 1]}
						yFormat={(y) => (y * 100).toFixed() + '%'}
					/>
				</Box>
			</Flex>
		</DashboardCard>
	);
}
